<template >
    <div class="home-cover" >
        <div class="container d-flex align-items-center">
            <div class="image w-50">
                <div class="cover-image">
                    <img src="@/assets/home/teacher.webp" alt="">
                    <img class="watermelon-cover-image" src="@/assets/header icons/watermelon.png" alt="">
                    <img class="watermelon-cover-image-2" src="@/assets/home/watermelon (1).png" alt="">
                </div>
            </div>
            <div class="text">
                <p class="text-capitalize">khaled sakr store</p>
                <p class="hashtag">
                    #عمو_خالد #ستور
                </p>
                <p>
                    هتقدر تشوف وتتصفح وتشتري كل حاجه خاصه ب عمو خالد
                </p>
                <router-link v-if="!$store.state.isAuthenticated" :to="{name:'login'}" class="lets-join">
                    <img src="@/assets/header icons/sweater.png" alt="">
                    يلا سجل معانا
                </router-link>
                <router-link v-else :to="{name:'products_all'}" class="lets-join">
                    <img src="@/assets/header icons/sweater.png" alt="">
                    يلا شوف جميع المنتجات من هنا!
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CoverComponent'
}
</script>
<style scoped>
    .home-cover {
        min-height: 70vh;
        padding: 1rem 0;
    }
    .home-cover .text {
        background-image: url('@/assets/home/Vector.webp');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        width: 50%;
        height: 100%;
    }
    .home-cover .text p:nth-child(1) {
        color: #16C47F;
        margin: 0;
        font-size: 4rem;
        font-weight: bold;
        letter-spacing: 2px;
    }
    .home-cover .text p.hashtag {
        font-size: 2rem;
        color: transparent;
        -webkit-text-stroke: 1.4px #81BFDA; /* Border size and color */
        opacity: 0.5;
    }
    .home-cover .text p:nth-child(3) {
        font-size: 2rem;
        color: rgb(107 114 128/1);
    } 
    .lets-join {
        all: unset;
        padding: 1rem 1.5rem;
        text-align: center;
        background-color: #FF7070;
        color: #fff;
        font-weight: bold;
        font-size: 1.2rem;
        border: 1.4px solid #FF7070;
        transition: all 0.5s;
        cursor: pointer;
        border-radius: 5px;
    }
    .lets-join:hover {
        background-color: transparent ;
        color: #FF7070;
    }
    .lets-join img {
        width: 40px;
        height: 40px;
        margin-left: 0.5rem;
    }
    .image  {
        display: flex;
        justify-content: center;
        position: relative;
    }
    .image::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 70%;
        height: 150px;
        z-index: -2;
        background-color: #B1F0F7;
        border-radius:8px;
    }
    .image .cover-image {
        width: 200px;
        position: relative;
    }
    .image .cover-image img:nth-child(1) {
        width: 100%;
        object-fit: contain;
        filter: drop-shadow(0px 5px 7px rgb(107 114 128/1));
    }
    .watermelon-cover-image {
        width: 80px;
        height: 80px;
        position: absolute;
        bottom: 0;
        right: -40px;
        /* z-index: -1; */
    }
    .watermelon-cover-image-2 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 0;
        left: -40px;
        /* z-index: -1; */
    }
    @media(max-width:767px) {
        .home-cover .container {
            flex-direction: column;
        }
        .home-cover .container .image , 
        .home-cover .container .text ,
        .image::after  {
            width: 100% !important;
        }
        .home-cover .container .image {
            margin-bottom: 1rem;
        }
        /* .image .cover-image {
            width: 100%;
        } */
        .lets-join {
            font-size: 0.8888rem;
        }
    }
</style>